import type { GifData } from './types';

export function isValidData(value: unknown): value is GifData {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.url === 'string' &&
    typeof v.stillUrl === 'string' &&
    typeof v.width === 'number' &&
    typeof v.height === 'number' &&
    (v.source === 'klipy' || v.source === 'giphy')
  );
}
